<template>
  <div
    class="c-profile-card"
    :class="{'c-profile-card--mini' : mini, 'no-border':noBorder,'c-profile-card--large' : large}"
    @click="$emit('click')"
    @focus="$emit('focus')"
    @blur="$emit('blur')"
    tabindex="0"
  >
    <article role="article" class="c-profile-card__meta">
      <header>
        <h4 class="c-profile-card__name">
          <router-link
            :to="{name:'CurrentUserProfile'}"
            v-if="!mini"
            v-on:click.native="$emit('profileClick');"
          >{{currentUser.name}}</router-link>
          <span v-else>{{currentUser.name}}</span>
        </h4>
      </header>
      <section v-if="!mini">
        <p>
          {{currentUser.position}}
          <br>
          {{currentUser.location}}
        </p>
      </section>
      <footer v-if="!mini">
        <router-link
          :to="{name: 'CurrentUserProfile'}"
          v-on:click.native="$emit('profileClick');"
        >Edit Profile</router-link>
        {{' '}}|{{' '}}
        <router-link :to="{name: 'Logout'}">Log out</router-link>
      </footer>
    </article>

    <notification-count :count="notificationCount" v-if="showNotifications" badge>
      <div class="c-profile-card__avatar">
        <user-avatar :user="currentUser" v-if="loaded"/>
      </div>
    </notification-count>
    <div class="c-profile-card__avatar" v-else>
      <user-avatar :user="currentUser" v-if="loaded"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import NotificationCount from '@/components/BaseNotificationCount';
import axios from 'axios';

const UserAvatar = () => import('@/components/UserAvatar');
export default {
  name: 'ProfileCard',
  props: {
    mini: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
    showNotifications: {
      type: Boolean,
      default: false,
    },
    notificationCount: {
      type: [String, Number],
      default: 0,
    },
  },
  components: {
    NotificationCount,
    UserAvatar,
  },

  computed: {
    ...mapState('auth', ['currentUser']),
  },

  methods: {
    gotoProfile() {
      this.$router.push({ name: 'Profile' });
    },
  },

  data() {
    return {
      loaded: false,
    };
  },

  created() {
    // if (!this.$store.state.auth.currentUser.id) {
    this.loaded = false;
    this.$store.dispatch('auth/listCurrentUser').then((resp) => {
      this.loaded = true;
    });
    // }
    this.loaded = false;
  },
};
</script>

<style scoped lang="scss">
.c-profile-card {
  border: 1px solid $colour-nhs-pale-grey;
  background: $colour-nhs-white;
  margin-left: 10px;
  flex-direction: row-reverse;
  display: flex;
  // font-size: 1.33333rem;

  a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  &__meta {
    flex: 2;
    text-align: left;

    h4 {
      margin: 0 0 10px;
      font-size: 1rem;
      color: $colour-nhs-core-blue;
      font-weight: bold;
      font-family: $font-frutiger-bold;
    }
  }

  &__avatar {
    width: 85px;
    max-width: 60px;
    border-radius: 100%;
    display: inline-flex;
    overflow: hidden;
    margin-right: 20px;
    max-height: 60px;
    height: 85px;
    flex: 1;

    @media screen and (min-width: 1024px) {
      max-width: 85px;
      max-height: 85px;
    }

    img {
      width: auto;
      height: 100%;
      margin: 0 auto;
      display: block;
      @supports (object-fit: cover) {
        min-height: 39px;
        width: 100%;
        min-width: 39px;
        height: 100%;
        max-height: 60px;
        max-width: 60px;
        object-fit: cover;

        @media screen and (min-width: 1024px) {
          max-width: 85px;
          max-height: 85px;
        }
      }
    }
  }
  &--mini {
    display: inline-flex;
    @media screen and (min-width: 1151px) {
      display: inline-flex;
      padding-left:8px;
    }
    border-radius: 72px;
    align-items: center;
    flex-direction: row;

    padding: 5px;

    @media screen and (min-width: 1200px) {
      padding: 5px 5px 5px 10px;
    }

    &:hover {
      border-color: $colour-nhs-core-blue;
      color: $colour-nhs-core-blue;
      cursor: pointer;
    }

    .c-profile-card__name {
      display: none;
      @media screen and (min-width: 1151px) {
        display: inline;
      }
    }
  }

  &--mini & {
    &__avatar {
      max-width: 39px;
      max-height: 39px;
      margin-right: 0;
    }

    &__meta {
      flex: auto;
      h4 {
        margin: 0 10px 0 0;
        color: $colour-nhs-dark-grey;
        font-weight: normal;
        font-family: $font-frutiger-roman;
      }

      section,
      footer {
        display: none;
      }
    }
  }

  &--large {
    flex-wrap: wrap-reverse;
    flex-direction: row;
  }

  &--large & {
    &__avatar,
    &__meta {
      margin: 10px auto;
      text-align: center;
      flex-basis: 100%;
    }
  }

  &.no-border {
    border: none;
  }
}
</style>
